import { Button } from "primereact/button";
import React from "react";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type invoiceDataForm_OrderFragment$key } from "@relay/invoiceDataForm_OrderFragment.graphql";
import { ORDER_FRAGMENT } from "./invoice-data-form.graphql";
import { type InvoiceDataFormProps } from "./invoice-data-form.interface";
import { TextDisplayField } from "../../../../components/text-display-field/text-display-field.component";

export const InvoiceDataForm = ({ orderFragmentRef }: InvoiceDataFormProps) => {
	const { t } = useTranslation("common");
	const order = useFragment<invoiceDataForm_OrderFragment$key>(ORDER_FRAGMENT, orderFragmentRef);

	const downloadInvoicePDF = () => {
		if (order.invoiceData?.invoiceFile?.url) {
			const link = document.createElement("a");
			link.href =
				"data:application/octet-stream;base64," + order.invoiceData?.invoiceFile?.url;
			link.download = order.invoiceData.invoiceNumber + ".pdf";
			link.click();
		}
	};

	const invoiceId = order.invoiceData?.invoiceId;
	const invoiceNumber = order.invoiceData?.invoiceNumber ?? undefined;

	return order.invoiceData ? (
		<div>
			<div className="formgrid grid">
				<TextDisplayField label={t("order.invoiceId")} value={invoiceId} />
				<TextDisplayField label={t("order.invoiceNumber")} value={invoiceNumber} />
			</div>
			{order.invoiceData.invoiceFile?.url && (
				<Button
					onClick={downloadInvoicePDF}
					label={t("order.pdfDownload")}
					icon="pi pi-download"
				/>
			)}
		</div>
	) : (
		<h4>{t("order.noInvoiceData")}</h4>
	);
};
